<template>
  <BaseDialog
    :title="displayText.title"
    width="600px"
    :close-on-click-modal="false"
    :btn1="displayText.btnText.save"
    :btn2="displayText.btnText.cancel"
    :btn1-loading="loading"
    @close="$emit('close')"
    @cancel="$emit('close')"
    @confirm="onSave"
  >
    <BaseElForm ref="formRef" :model="formData" :rules="formRules" label-position="top" label-width="120px">
      <BaseElFormItem :label="displayText.formLabel" prop="adminQuickPaymentUrl">
        <BaseElInput
          v-model="formData.adminQuickPaymentUrl"
          :placeholder="displayText.placeholder"
          style="width: 100%"
        />
      </BaseElFormItem>
    </BaseElForm>
  </BaseDialog>
</template>

<script>
import { defineComponent, reactive, computed, onMounted } from 'vue'
import { UpdateReservationParameter } from '@/api/reservation'
import { useShop } from '@/use/shop'
import { useBaseForm } from '@/use/useForm'
import BaseDialog from '@/components/Dialog/BaseDialog.vue'
import notifyMessage from '@/config/notifyMessage'

export default defineComponent({
  name: 'EditQuickPaymentLinkModal',
  components: {
    BaseDialog,
  },
  props: {
    adminQuickPaymentUrl: {
      type: String,
      default: '',
    },
  },
  emits: ['close', 'refresh'],
  setup (props, { emit }) {
    const { shopId } = useShop()
    const { formRef, formData, initFormData, loading } = useBaseForm()

    // 表單驗證規則
    const formRules = reactive({
      adminQuickPaymentUrl: [
        {
          required: true,
          message: '請輸入收款連結',
          trigger: 'blur',
        },
        {
          validator: (rule, value, callback) => {
            if (value && !/^https?:\/\//.test(value)) {
              callback(new Error('請輸入有效的 URL 格式'))
            } else {
              callback()
            }
          },
          trigger: 'blur',
        },
      ],
    })

    // 顯示文字
    const displayText = computed(() => ({
      title: '編輯收款連結設定',
      formLabel: '連結設定',
      placeholder: '請輸入',
      btnText: {
        save: '確認',
        cancel: '取消',
      },
    }))

    // 儲存設定
    const onSave = async () => {
      try {
        // 手動驗證表單
        if (!formData.adminQuickPaymentUrl) {
          window.$message.error('請輸入收款連結')
          return
        }
        if (!/^https?:\/\//.test(formData.adminQuickPaymentUrl)) {
          window.$message.error('請輸入有效的 URL 格式')
          return
        }

        loading.value = true

        const payload = {
          shopId: shopId.value,
          adminQuickPaymentUrl: formData.adminQuickPaymentUrl,
        }

        const [, errMsg] = await UpdateReservationParameter(payload)
        if (errMsg) {
          window.$message.error(errMsg)
          return
        }

        window.$message.success(notifyMessage.updateSuccess)
        emit('refresh')
        emit('close')
      } catch (error) {
        console.error('儲存失敗:', error)
        window.$message.error('儲存失敗')
      } finally {
        loading.value = false
      }
    }

    onMounted(() => {
      initFormData({
        adminQuickPaymentUrl: props.adminQuickPaymentUrl || '',
      })
    })

    return {
      formRef,
      formData,
      formRules,
      loading,
      displayText,
      onSave,
    }
  },
})
</script>

<style lang="postcss" scoped>
.form-tip {
  @apply text-gray-500 text-sm mt-1;
}
</style>
